/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-bulk-action-modal.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-creative-bulk-action-modal',
  template
})
export class CreativeBulkActionModalComponent implements OnInit {
  list: any;

  item: any = {
    name: '{currentName}',
    urlType: 'REPLACE'
  };
  form: any = {};
  editing: any = {};
  count = 0;
  creativeType: string;

  constructor(public bsModalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.count = _.keys(this.list?.bulkSelection || {}).length;
    this.creativeType = this.list?.creativeType;
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  cancelShareOfVoice(): void {
    this.item.sponsorshipPercentage = undefined;
  }

  apply(): void {
    const creatives = _.map(this.list.bulkSelection, (v: any, k: string) => {
      const obj: any = {id: k};

      if (this.editing.name && this.item.name) {
        obj.name = this.item.name.replace('{currentName}', v.name);
      }
      if (this.editing.userState && this.item.userState) {
        obj.userState = this.item.userState;
      }
      if (this.editing.shareOfVoice) {
        obj.sponsorshipPercentage = this.item.sponsorshipPercentage;
      }
      if (this.editing.url && this.item.url) {
        obj.layoutParameters = obj.layoutParameters || {};
        obj.layoutParameters.specialOverrideUrlParameter = (this.item.urlType === 'REPLACE' ? '' : '{url}') + this.item.url;
      }

      return obj;
    });

    this.list.miscBulkAction(
      {close: () => this.bsModalRef.hide()},
      this,
      creatives
    );
  }
}
